import { useQuery } from "@tanstack/react-query"

import { ContentService } from "@/client"
import type { TopicQuestionsPublic } from "@/client/types.gen"

import { topicQueryKeys } from "./useTopicQuestions"

interface UntaggedParams {
  search?: string
  page: number
  pageSize: number
}

export function useUntaggedQuestions({
  search,
  page,
  pageSize,
}: UntaggedParams) {
  return useQuery<TopicQuestionsPublic>({
    queryKey: topicQueryKeys.untagged({ page, search }),
    queryFn: () =>
      ContentService.listQuestionsWithoutTopics({
        q: search,
        page,
        pageSize,
      }),
    placeholderData: (previousData) => previousData,
  })
}
